import {AssignationSalesView} from "./view/AssignationSalesView";
import {requestService} from "../../services/RequestService";
import {ApiRoutes} from "../../routes/ApiRoutes";
import {AssignationRequestUpdateDTO} from "./dto/AssignationRequestUpdateDTO";
import {BbxRequest} from "../../data/Request/BbxRequest";
import {SearchAssignationSalesRequestDTO} from "./dto/SearchAssignationSalesRequestDTO";
import {Page} from "../../data/Page";
import {SearchAssignationSalesResultView} from "./view/SearchAssignationSalesResultView";
import {AssignationSalesCountPerYearMonthView} from "./view/AssignationSalesCountPerYearMonthView";
import {AssignationSalesRequestDTO} from "./dto/AssignationSalesRequestDTO";

export const AssignationSalesModelAPI = {
    /**
     * Fetches assignation sales by supplier (user ID).
     * @param {number} userId - The ID of the user (supplier).
     * @returns {Promise<AssignationSalesView[]>} Promise resolving to an array of AssignationSalesView.
     */
    findAllBySupplierId: async (userId: number): Promise<AssignationSalesView[]> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_ASSIGNATION_SALES + "/" + userId, {});

        return response.data.map((item: any) => new AssignationSalesView(item));
    },

    /**
     * Creates a new assignation sales entry.
     * @param {AssignationSalesRequestDTO} assignationRequestDTO - The DTO containing assignation sales data.
     * @returns {Promise<Boolean>} Promise resolving to true if the creation was successful.
     */
    create: async (assignationRequestDTO: AssignationRequestUpdateDTO): Promise<Boolean> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_ASSIGNATION_SALES_CREATE, assignationRequestDTO);

        return response.data;
    },


    /**
     * Updates an assignation sales entry.
     * @param {AssignationSalesRequestDTO} assignationRequestDTO - The DTO containing updated assignation sales data.
     * @returns {Promise<Boolean>} Promise resolving to true if the update was successful.
     */
    update: async (assignationRequestDTO: AssignationRequestUpdateDTO): Promise<Boolean> => {
        const response = await requestService.put(ApiRoutes.REST_API_URL_ASSIGNATION_SALES_UPDATE, assignationRequestDTO);

        return response.data;
    },

    /**
     * Update an assignation sales status depending on the button in table.
     * @param {AssignationSalesRequestDTO} assignationRequestDTO - The DTO containing updated assignation sales data.
     * @returns {Promise<Boolean>} Promise resolving to true if the update was successful.
     */
    updateAssignationStatus: async (assignationRequestDTO: AssignationRequestUpdateDTO): Promise<Boolean> => {
        const response = await requestService.put(ApiRoutes.REST_API_URL_ASSIGNATION_SALES_UPDATE_STATUS, assignationRequestDTO);

        return response.data;
    },

    /**
     * Search assignation sales based on the provided request object.
     * @returns {Promise<Page<SearchAssignationSalesResultView>>} Promise resolving to a Page of SearchAssignationSalesResultView.
     * @param request
     */
    searchAssignationSales: async (request: BbxRequest<SearchAssignationSalesRequestDTO>): Promise<Page<SearchAssignationSalesResultView>> => {
        const response = await requestService.post(ApiRoutes.REACT_API_URL_ASSIGNATION_SALES_SEARCH, request);
        return new Page(SearchAssignationSalesResultView, response.data);

    },

    /**
     * Gets assignation sales count per year and month for a given administrator.
     * @returns {Promise<AssignationSalesCountPerYearMonthView[]>} Promise resolving to an array of AssignationSalesCountPerYearMonthView.
     * @param administratorId
     */
    getAssingnationSalesPerYearMonth: async (searchAssignationSalesRequestDTO: AssignationSalesRequestDTO): Promise<AssignationSalesCountPerYearMonthView[]> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_ASSIGNATION_SALES_YEAR_MONTH, searchAssignationSalesRequestDTO);

        return response.data.map((item: any) => new AssignationSalesCountPerYearMonthView(item));
    },

    /**
     * Gets assignation sales by vendor ID.
     * @returns {Promise<Page<SearchAssignationSalesResultView>>} Promise resolving to a Page of SearchAssignationSalesResultView.
     * @param request
     */
    getAssignationSalesByVendorId: async (request: BbxRequest<AssignationSalesRequestDTO>): Promise<Page<SearchAssignationSalesResultView>> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_ASSIGNATION_SALES_PROSPECTS, request);

        return new Page(SearchAssignationSalesResultView, response.data);
    },

    /**
     * Gets the count of prospects assigned to the current user.
     * @returns {Promise<number>} Promise resolving to the count of prospects.
     */
    getMyProspectsCounter: async (): Promise<number> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_ASSIGNATION_SALES_PROSPECTS_COUNTER);
        return response.data as number;
    }
};